module.exports = __webpack_public_path__ + "img/icon_detials.91ca15d5.svg";